<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="form-group form-actions float-right pb-2">
          <b-button class="mr-2" type="submit" size="md" variant="primary" @click="newClient">
            <i class="fa fa-handshake-o"></i>
            New Client
          </b-button>
        </div>
        <div>
          <StyledDialog>
            <div slot="header">
              <h2>{{client.client_edit.LegalName}}</h2>
            </div>
            <div slot="details">
              <div>{{client.client_edit.CommonName}}</div>
              <div>{{client.client_edit.Website}}</div>
            </div>
            <span slot="entityType">location</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="client.clients"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "ClientList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        { key: "LegalName", label: "Legal", sortable: true },
        { key: "CommonName", label: "Common", sortable: true },
        { key: "IsClient", label: "Client", sortable: false },
        { key: "Website", label: "Website", sortable: false }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 10
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.$store.dispatch("client/fetchClients");
  },
  computed: {
    totalRows: function() {
      return this.$store.state.client.clients.length;
      //return 4;
    },
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    ...mapState(["client", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')

      //this.mySelected = record;

      this.$store.dispatch("client/loadClientEdit", record.ClientID);
      this.$router.push({ path: "clients/" + record.ClientID });
    },
    newClient() {
      this.$store.dispatch(
        "client/createClient",
        this.createFreshClientObject()
      );
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshClientObject() {
      return {
        id: -1,
        CommonName: "New Client",
        LegalName: "Test"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
</style>